import Match from '@/models/match'

class Set {

    constructor(
        id,
        type,
        number,
        start_date,
        tournament_id,
        matches
    ) {
        this.id = id || null
        this.type = type || ''
        this.number = number || ''
        this.start_date = start_date || ''
        this.tournament_id = tournament_id || ''
        this.matches = matches || ''
    }

    static parse(responseData) {
        if(!responseData) return new Set()
        let d = responseData
        var matches = []
        if(d.matches){
          for(var i = 0; i < d.matches.length; i++){
            let match = Match.parse(d.matches[i])
            matches.push(match)
          }
        }
        return new Set(
            d.id,
            d.type,
            d.number,
            d.start_date,
            d.tournament_id,
            matches
        )

    }

}

export default Set



// WEBPACK FOOTER //
// ./src/models/set.js